import { propTypes } from '@tabeo/scarf'
import React from 'react'
import { Navigate, useLocation } from 'react-router'
import { useAuth } from 'resources/Auth'

// v6 has no custom <Route> components: this is a guard that renders its children
// when authenticated, otherwise redirects to /login (preserving the attempted
// location in state.from, as the v5 <Redirect> did).
function RequireAuth({ children }) {
  const location = useLocation()
  const {
    data: { token },
  } = useAuth()

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return children
}

RequireAuth.propTypes = {
  children: propTypes.children,
}

export default RequireAuth
